import React from "react";

const SearchTop = ({ check1, setCheck1, check2, setCheck2, TnvedOpen }) => {

    const checkClick1 = () => {
        setCheck1(true);
        setCheck2(false);
    }

    const checkClick2 = () => {
        setCheck1(false);
        setCheck2(true);
    }

    return (
        <div className="flex justify-between font-medium">
            <div className="flex flex-wrap items-center gap-[16px] sm:gap-[20px]">
                <div className="text-[#1F2225] sm:text-[48px] text-[32px]">Поиск товара</div>
                <div className="flex items-center gap-[8px] flex-wrap">
                    <div onClick={checkClick1} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-solid border-[#C9CED2] border-[1px] gap-2 items-center pr-[8px]'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                            {check1 && <img className='w-[80%] h-[80%]' src='/img/search/checkImg.png' alt="Checked" />}
                        </div>
                        <span className='sm:text-[16px] text-[14px]'>Поиск по наименованию / коду</span>
                    </div>

                    <div onClick={checkClick2} className='cursor-pointer p-[6px] flex flex-row w-fit rounded-full border-solid border-[#C9CED2] border-[1px] gap-2 items-center pr-[8px]'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check2 ? 'bg-[#353A40]' : 'bg-[#C9CED2]'} h-[20px] rounded-full`}>
                            {check2 && <img className='w-[80%] h-[80%]' src='/img/search/checkImg.png' alt="Checked" />}
                        </div>
                        <span className='sm:text-[16px] text-[14px]'>Дерево ТН ВЭД</span>
                    </div>
                </div>
            </div>
            <div>
                <button onClick={TnvedOpen}>
                    <svg className="sm:w-[64px] w-[34px]" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M51.771 16.0017L47.9997 12.2305L31.9998 28.2305L15.9998 12.2305L12.2285 16.0017L28.2285 32.0017L12.2285 48.0017L15.9998 51.7729L31.9998 35.7729L47.9997 51.7729L51.771 48.0017L35.771 32.0017L51.771 16.0017Z" fill="#626C75"/>
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default SearchTop;
